'use client';
import { useEffect, useState } from 'react';
import { getBookmarks } from '@/lib/firebase/getBookmarks';
import useUser from '@/hooks/useUser';
import { useAuth } from '@/providers/AuthProvider';
import SpinnerIcon from '@/icons/SpinnerIcon';
import { cn } from '@pulsex/utils';
import pulseConfig from '@/pulsex.config';
import HorizontalCard from '@/components/Card/HorizontalCard';

export default function BookmarksPage({ isMobile }: any) {
    const user = useUser();
    const { authReady } = useAuth();
    const [bookmarks, setBookmarks] = useState<any[]>([]);
    const [isBookmarksLoading, setIsBookmarksLoading] = useState(true);

    useEffect(() => {
        if (!authReady || !user) {
            if (authReady && !user) setIsBookmarksLoading(false);
            return;
        }
        const fetchBookmarks = async () => {
            try {
                const data = await getBookmarks(user.uid);
                setBookmarks(data);
            } catch (error) {
                console.error('Error fetching bookmarks:', error);
            } finally {
                setIsBookmarksLoading(false);
            }
        };
        fetchBookmarks();
    }, [user, authReady]);

    if (!authReady) {
        return (
            <div className="p-4 container">
                <h2 className="text-3xl font-medium mb-6">المكتبة الرقمية</h2>
                <div className="w-full flex items-center justify-center">
                    <SpinnerIcon className="w-8 h-8" />
                </div>
            </div>
        );
    }

    if (!user) {
        return <div className="p-4 container mb-40">Please login to view your bookmarks.</div>;
    }

    return (
        <div className="p-4 container">
            <h2 className="text-3xl font-medium mb-6">المكتبة الرقمية</h2>
            {isBookmarksLoading ? (
                <div className="w-full flex items-center justify-center">
                    <SpinnerIcon className="w-8 h-8" />
                </div>
            ) : bookmarks.length === 0 ? (
                <p>No bookmarks yet.</p>
            ) : (
                <div className={cn('flex w-full flex-col', 'md:w-full')}>
                    <div
                        className={cn('flex flex-col gap-8')}
                        dir={pulseConfig.LANGUAGE === 'ar' ? 'rtl' : 'ltr'}
                    >
                        {bookmarks?.map((bookmark: any, index: number) => {
                            const modifiedBookmark = {
                                ...bookmark,
                                tag: {
                                    title: bookmark.title,
                                },
                            };

                            return (
                                <HorizontalCard
                                    key={index}
                                    data={modifiedBookmark}
                                    widgetTitle={bookmark.title}
                                    widgetColor={'#c80f1e'}
                                    className="flex-1 max-md:mb-6"
                                    cropSize="medium"
                                    isMobile={isMobile}
                                />
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}
